import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ProtectedRoute from './ProtectedRoute';
import SecuredRouter from './SecuredRouter';
import LoginPage from '@pages/Giris';

const AppRouter = () => {
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

    return (
        <Routes>
            {/* Public Routes */}
            <Route
                path="/giris"
                element={!isAuthenticated ? <LoginPage /> : <Navigate to="/" replace />}
            />

            {/* Legacy redirect */}
            <Route
                path="/login"
                element={<Navigate to="/giris" replace />}
            />

            {/* Protected Routes */}
            <Route path="/*" element={<ProtectedRoute />}>
                <Route path="*" element={<SecuredRouter />} />
            </Route>
        </Routes>
    );
};

export default AppRouter;
